// extracted by mini-css-extract-plugin
export default {"title-group":"style_title-group__ncKFN","dropdown":"style_dropdown__b727J","wrapper":"style_wrapper__U4OfU","diseases":"style_diseases__nIy86"};